<div class=" divFondo">
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>¿Recomendarías a tus conocidos o amigos que trabajen aquí en esta empresa? (Por favor califícalo del 0 al 10 donde 0 es "No, nunca lo haría"… y 10 es "Sí, estoy 100% seguro que lo haría")</h3>
    <mat-radio-group aria-label="Select an option"  fxLayout="file" fxLayoutAlign="space-between stretch">
      <mat-radio-button value="1"> 1</mat-radio-button>
      <mat-radio-button value="2"> 2</mat-radio-button>
      <mat-radio-button value="3"> 3</mat-radio-button>
      <mat-radio-button value="4"> 4</mat-radio-button>
      <mat-radio-button value="5"> 5</mat-radio-button>
      <mat-radio-button value="6"> 6</mat-radio-button>
      <mat-radio-button value="7"> 7</mat-radio-button>
      <mat-radio-button value="8"> 8</mat-radio-button>
      <mat-radio-button value="9"> 9</mat-radio-button>
      <mat-radio-button value="10"> 10</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3> Y ¿Por qué? (pregunta abierta)</h3>
    <mat-form-field>
      <textarea matInput placeholder="Describe Por que" required></textarea>
    </mat-form-field>

  </div>
  <!-- Step Control-->
  <!-- <mat-step>
  <ng-template matStepLabel>Control</ng-template>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
  <h3>Recibiste alguna presión o incentivo de parte de tus líderes u otras áreas de tu empresa para contestar de cierta forma a la encuesta</h3>

  <mat-radio-group aria-label="Select an option" formControlName="firstCtrl" class="example-radio-group">
  <mat-radio-button value="1">Si</mat-radio-button>
  <mat-radio-button value="2">No</mat-radio-button>
</mat-radio-group>
</div>
<div >
<h2 class="pr-20">Siguiente</h2>
<button  matStepperNext mat-fab color="primary"  aria-label="agregaPreg" >
<mat-icon>keyboard_arrow_right</mat-icon>
</button>
<h2 class="pr-20">Anterior</h2>
<button  matStepperPrevious mat-fab color="primary"  aria-label="agregaPreg" >
<mat-icon> keyboard_arrow_left</mat-icon>
</button>
</div>
</mat-step> -->
<!-- Step Demograficos-->
<!-- <mat-step>
<ng-template matStepLabel>Demograficos</ng-template>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>A. ¿Cuántos años en total tienes de ser responsable de gente bajo tu cargo en esta u otras empresas en las que has trabajado?</h3>
<mat-radio-group aria-label="Select an option" formControlName="firstCtrl"  class="example-radio-group">
<mat-radio-button value="1">No tengo ni he tenido gente bajo mi cargo</mat-radio-button>
<mat-radio-button value="2">Hasta 2 años</mat-radio-button>
<mat-radio-button value="3">2 a 5 años</mat-radio-button>
<mat-radio-button value="4">6 a 10 años</mat-radio-button>
<mat-radio-button value="5">Más de 10 años</mat-radio-button>
</mat-radio-group>
</div>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3> B. ¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa?</h3>

<mat-radio-group aria-label="Select an option" formControlName="firstCtrl"  class="example-radio-group">
<mat-radio-button value="1">Mucha confianza</mat-radio-button>
<mat-radio-button value="2">Algo de confianza</mat-radio-button>
<mat-radio-button value="3">Poca confianza</mat-radio-button>
<mat-radio-button value="4">Nada de confianza</mat-radio-button>
</mat-radio-group>
</div>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>C. En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de hacer el trabajo?</h3>

<mat-radio-group aria-label="Select an option" formControlName="firstCtrl"  class="example-radio-group">
<mat-radio-button value="1">Muchas oportunidades</mat-radio-button>
<mat-radio-button value="2">Algunas oportunidades</mat-radio-button>
<mat-radio-button value="3">Pocas oportunidades</mat-radio-button>
<mat-radio-button value="4">Casi ninguna o ninguna oportunidad</mat-radio-button>
</mat-radio-group>
</div>
<div >
<button mat-button matStepperPrevious>Back</button>
<button mat-button matStepperNext>Next</button>
</div>
</mat-step> -->
<!-- Step ForALL-->
<!-- <mat-step>
<ng-template matStepLabel>ForAll</ng-template>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>¿Conoces o has participado en p1 en tu lugar de trabajo? . - p1d</h3>

<mat-radio-group aria-label="Select an option" formControlName="firstCtrl"  class="example-radio-group">
<mat-radio-button value="1">Si</mat-radio-button>
<mat-radio-button value="2">No</mat-radio-button>

</mat-radio-group>
</div>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>¿Conoces o has participado en p2 en tu lugar de trabajo? . - p2d</h3>

<mat-radio-group aria-label="Select an option" formControlName="firstCtrl"  class="example-radio-group">
<mat-radio-button value="1">Si</mat-radio-button>
<mat-radio-button value="2">No</mat-radio-button>
</mat-radio-group>
</div>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>¿Conoces o has participado en p3 en tu lugar de trabajo? . - p3d</h3>

<mat-radio-group aria-label="Select an option" formControlName="firstCtrl"  class="example-radio-group">
<mat-radio-button value="1">Si</mat-radio-button>
<mat-radio-button value="2">No</mat-radio-button>
</mat-radio-group>
</div>
<div >
<button mat-button matStepperPrevious>Back</button>
<button mat-button matStepperNext>Next</button>
</div>
</mat-step> -->
<!--Step Abiertas-->
<!-- <mat-step>
<ng-template matStepLabel>Abiertas</ng-template>

<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>¿Existe algo especial o único en tu empresa que lo caracterice como un gran lugar para trabajar? Da ejemplos.</h3>
<mat-form-field>
<textarea matInput placeholder="Requerida"></textarea>
</mat-form-field>

</div>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3> Si pudieras cambiar algo acerca de tu empresa para hacerla un mejor lugar para trabajar, ¿qué cambiarías? Da ejemplos.</h3>
<mat-form-field>
<textarea matInput placeholder="Requerida"></textarea>
</mat-form-field>

</div>
<div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
<h3>¿Cuáles son las fortalezas de tu líder directo? Da ejemplos.</h3>
<mat-form-field>
<textarea matInput placeholder="Requerida"></textarea>
</mat-form-field>

</div>

<div >
<button mat-button matStepperPrevious>Back</button>
<button mat-button matStepperNext>Next</button>
</div>
</mat-step> -->

</div>
